declare global {
  interface Window {
    ga: any;
  }
}

const pageview = () => {
  window.ga("send", "pageview");
};

const page = (path: string) => {
  window.ga("set", "page", "/" + path);
  pageview();
};

const bucket = (bucket: string) => {
  window.ga("set", "dimension1", bucket);
};

const button = (title: string) => {
  window.ga("send", "event", "Button", title);
};

const toggle = (title: string) => {
  window.ga("send", "event", "Toggle", title);
};

const checkbox = (label: string, checked: boolean) => {
  window.ga("send", "event", "Checkbox", label, checked.toString());
};

/**
 * Make sure to update the type definition for each new method added
 * in `@/plugins/google-analytics/index.ts`
 */

export default {
  pageview,
  page,
  bucket,
  button,
  toggle,
  checkbox,
};
